import {flatten, groupBy, orderBy, map, mean, meanBy} from 'lodash-es';

import {Liquid} from "liquidjs";
import SVGModel from '../Models/svgModel';
import Graphic from '../Models/reportGraphic';
import Template from '../Models/templateModel';
import {getJWT} from '../Utilities/Session.svelte';

const risk_list = ['low', 'medium', 'high'];


/* liquid JS */
export const engine = new Liquid({
    timezoneOffset: 0,
    fs:  {
        readFileSync (file) {
           throw new Error("Cannot Use RenderSync with render tag")
        },
        async readFile (file) {
            const template = await Template.getTemplateByName(file);

            return template.body
        },
        existsSync () {
            return true
        },
        exists () {
            return true
        },
        contains () {
            return true
        },
        resolve(root, file, ext) {
            return file
        }
    },
    relativeReference: false
});

function degToRad(deg) {
    return (deg * Math.PI / 180)
}

engine.registerTag('svg', {
    parse: function(tagToken, remainTokens) {
        this.str = tagToken.args; // name
    },

    render: async function(ctx) {
        var str = await this.liquid.evalValue(this.str, ctx);

        var results = await SVGModel.getSVGByName(str);

        if (results.docs.length) {
            return results.docs[0].svg
        } else {
            throw new Error("Invalid SVG")
        }
    }
});

engine.registerTag("graphic", {
    parse: function (tagToken, remainTokens) {
        this.str = tagToken.args; // name
    },

    render: async function(ctx) {
        var str = await this.liquid.evalValue(this.str, ctx);

        var graphic_template = await Graphic.getGraphicByName(str);
        let rendered_template = await engine.parseAndRender(graphic_template.template, ctx.environments);

        let jwt = await getJWT();

        let res = await fetch('/generate/image/', {
            method: "POST",
            body: JSON.stringify({
                height: graphic_template.height,
                width: graphic_template.width,
                html: rendered_template
            }),
            headers: {
                'Authorization': `Bearer ${jwt}`,
                "content-type": "application/json"
            }
        });

        if (res.status != 200) {
            let text = await res.text()
            throw new Error(text);
        }

        let rasterized = await res.blob();

        function blobToImage(blob) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                }
                reader.readAsDataURL(blob);
            })
        }

        return await blobToImage(rasterized);
    }
})

engine.registerFilter('sortRisk', (list, key) => {
    if (list == undefined || key == undefined) {
        return list;
    }

    list.sort((a, b) => {
        return risk_list.indexOf(b[key].toLowerCase()) - risk_list.indexOf(a[key].toLowerCase());
    })
    return list
})

engine.registerFilter("json_escape", (s) => {
    if (s) {
        return JSON.stringify(s).slice(1, -1);
    }

    return "";
});

engine.registerFilter('exclude', (items, key, value) => {
    return items.filter(s => s[key] != value);
})


engine.registerFilter('groupBy', groupBy);
engine.registerFilter('orderBy', orderBy);
engine.registerFilter('flatten', flatten);
engine.registerFilter('map', map);
engine.registerFilter('cos', Math.cos);
engine.registerFilter('sin', Math.sin);
engine.registerFilter('degToRad', degToRad);
engine.registerFilter('precision', (int, num) => int.toPrecision(num))
engine.registerFilter('mean', mean );
engine.registerFilter('meanBy', meanBy );
engine.registerFilter('values', (val) => val ? Object.values(val) : []);
engine.registerFilter('keys', Object.keys);
engine.registerFilter('entries', Object.entries);